import React from 'react';
import { LoadScript } from '@react-google-maps/api';

const GoogleMapsProvider = ({ children }) => (
  <LoadScript googleMapsApiKey={gon.google_api_key}>
    {children}
  </LoadScript>
);

export default GoogleMapsProvider; 